module.exports = __webpack_public_path__ + "img/00000.f3504ff1.webp";